// extracted by mini-css-extract-plugin
module.exports = {"result-config":"ResultConfig_result-config__1yDKl"};